import React from 'react';
import Typography from '@mui/material/Typography';
import useStyles from './styles';
import { Link } from '@elevator/ui';

/**
 * Component that displays terms acceptance text with links to Terms of Use and Privacy Policy.
 *
 * @param buttonText - The button text to reference in the acceptance message (default: "Pay & Submit")
 * @param termsUrl - URL for the Terms of Use link (default: "/legal/terms-of-service")
 * @param privacyUrl - URL for the Privacy Policy link (default: "/legal/privacy-policy")
 * @returns Typography component with acceptance text and legal links
 * @usedIn CheckoutForm component
 */
const AcceptTerms = ({
  buttonText = 'Pay & Submit',
  termsUrl = '/legal/terms-of-service',
  privacyUrl = '/legal/privacy-policy',
}: AcceptTermsProps) => {
  const { classes } = useStyles();

  return (
    <Typography variant={'caption'} data-component="AcceptTerms">
      By clicking &quot;{buttonText}&quot; I acknowledge that I have read and agree to the
      ELEVATOR
      <Link href={termsUrl} inline className={classes.links}>
        Terms of Use
      </Link>
      and
      <Link href={privacyUrl} inline className={classes.links}>
        Privacy Policy
      </Link>
    </Typography>
  );
};

export interface AcceptTermsProps {
  /** The button text to reference in the acceptance message */
  buttonText?: string;
  /** URL for the Terms of Use link */
  termsUrl?: string;
  /** URL for the Privacy Policy link */
  privacyUrl?: string;
}

export default AcceptTerms;
